import {
  pathogenicColor,
  likelyPathogenicColor,
  uncertainSignificanceColor,
  benignColor,
} from "../../../common/helpers/colors";
import { GET_MONTHS } from "../../../common/helpers/Constant";

export const getDateFormat = (d) => {
  const date = new Date(d);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  return `${day} ${GET_MONTHS[month]} ${year}`;
};

export const starColors = {
  5: pathogenicColor,
  4: likelyPathogenicColor,
  3: uncertainSignificanceColor,
  2: uncertainSignificanceColor,
  1: benignColor,
};

export const geneFields = [
  { key: "variant", title: "Variant", width: "15%" },
  {
    key: "clinical_significance",
    title: "Clinical significance",
    width: "11%",
  },
  { key: "rating", title: "Evidence Rating", width: "7%" },
  { key: "evidence_type", title: "Evidence", width: "10%" },
  { key: "disease", title: "Disease", width: "9%" },
  {
    key: "representative_transcript",
    title: "Representative Transcript",
    width: "10%",
  },
  { key: "info", title: "General Information", width: "9%" },
  { key: "pub_med_references", title: "Pubmed References", width: "9%" },
  { key: "drugs", title: "Drugs and Evidence Statement", width: "20%" },
];

export const variantFields = [
  {
    key: "clinical_significance",
    title: "Clinical significance",
    width: "12%",
  },
  { key: "rating", title: "Evidence Rating", width: "12%" },
  { key: "evidence_type", title: "Evidence", width: "12%" },
  { key: "disease", title: "Disease", width: "15%" },
  { key: "pub_med_references", title: "Pubmed References", width: "10%" },
  { key: "info", title: "General Information", width: "13%" },
  { key: "drugs", title: "Drugs and Evidence Statement", width: "26%" },
];

export const sortedResults = (result) => {
  const y = [].concat(result.items).sort((a, b) => {
    if (a.rating === undefined) {
      return 1;
    }
    if (b.rating === undefined) {
      return -1;
    }
    if (b.rating === a.rating) {
      const aa = JSON.stringify(a);
      const bb = JSON.stringify(b);
      return bb >= aa ? 1 : -1;
    }
    return b?.rating - a?.rating;
  });
  return y;
};
